import { Props } from './Bubble';
import { ChoiceBubble } from './ChoiceBubble';
import { ChoiceType } from '@raysee/schema';

export const ConfirmationBubble = (props: Props) => (
  <ChoiceBubble {...props} choices={[ChoiceType.No, ChoiceType.Yes]} />
);
